import { SCHEDULE_FILTER_COUNT_ZERO } from './ScheduleFilterChips.constants';

const MIN_CLASSPASS_DEMAND = 1;

function resolveClasspassSpotsUnfilled({ classpassSpotsUnfilled, spots = {} } = {}) {
  if (classpassSpotsUnfilled != null) {
    return classpassSpotsUnfilled;
  }

  const { classpassTotal, takenSpots = SCHEDULE_FILTER_COUNT_ZERO } = spots;

  return classpassTotal === SCHEDULE_FILTER_COUNT_ZERO ? Infinity : classpassTotal - takenSpots;
}

function hasClasspassSpotsUnavailable(classpassSpotsUnfilled) {
  return classpassSpotsUnfilled === SCHEDULE_FILTER_COUNT_ZERO || classpassSpotsUnfilled === Infinity;
}

export function getClientsWaitingScheduleFlags(
  schedule = {},
  { hasSpotManagePermission = true, opportunityActedOn = false } = {}
) {
  const { isFull, isInThePast, isLocked, opportunity, reservationsStopped, smartspotEnabled, spots = {} } = schedule;

  const classpassDemand = spots.classpassDemand || SCHEDULE_FILTER_COUNT_ZERO;
  const recommendation = Boolean(opportunity?.recommendation);
  const classpassSpotsUnavailable = hasClasspassSpotsUnavailable(resolveClasspassSpotsUnfilled(schedule));

  const canShowOpportunityAction =
    hasSpotManagePermission &&
    recommendation &&
    !isInThePast &&
    !isLocked &&
    !opportunityActedOn &&
    !reservationsStopped &&
    !smartspotEnabled;

  const canShowSmartSpotAddAction =
    hasSpotManagePermission &&
    !isFull &&
    !isInThePast &&
    !isLocked &&
    classpassSpotsUnavailable &&
    Boolean(smartspotEnabled);

  const canShowAddSpotAction =
    hasSpotManagePermission &&
    !isFull &&
    !isInThePast &&
    !isLocked &&
    classpassSpotsUnavailable &&
    !smartspotEnabled &&
    !recommendation &&
    classpassDemand >= MIN_CLASSPASS_DEMAND;

  const hasClientsWaiting =
    classpassDemand >= MIN_CLASSPASS_DEMAND &&
    (canShowOpportunityAction || canShowSmartSpotAddAction || canShowAddSpotAction);

  return {
    canShowAddSpotAction,
    canShowOpportunityAction,
    canShowSmartSpotAddAction,
    hasClientsWaiting,
  };
}

export function hasClientsWaitingSchedule(schedule, options) {
  return getClientsWaitingScheduleFlags(schedule, options).hasClientsWaiting;
}
